var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgScissors = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 41,
    viewBox: "0 0 52 41",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.533,
    height: 39.864,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_464",
    "data-name": "Group 464",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_463",
    "data-name": "Group 463",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M0,5.77A14.9,14.9,0,0,1,.971,3.284,6.8,6.8,0,0,1,7.33,0a9.864,9.864,0,0,1,9.209,5.94,6.76,6.76,0,0,1-.116,6.306c.174.108.323.207.477.3,2.444,1.4,4.891,2.789,7.324,4.2a.772.772,0,0,0,.855.017C31.841,13.315,38.622,9.9,45.373,6.424a4.577,4.577,0,0,1,4.182-.044A22.54,22.54,0,0,1,51.533,7.5L29.8,19.925c7.253,4.146,14.414,8.243,21.582,12.343-1.109,1.184-3.915,2.276-5.923,1.225C38.749,29.983,31.971,26.6,25.229,23.15a1.054,1.054,0,0,0-1.153.036c-2.35,1.371-4.723,2.709-7.087,4.061-.174.1-.342.21-.491.3a20.8,20.8,0,0,1,.626,2.116,7.561,7.561,0,0,1-1.186,5.421,10.228,10.228,0,0,1-10.2,4.643A6.683,6.683,0,0,1,.083,34.224c-.008-.05-.055-.094-.083-.138V32.2a1.261,1.261,0,0,0,.1-.248,8.555,8.555,0,0,1,2.022-4.224,11.189,11.189,0,0,1,7.291-3.722A27.666,27.666,0,0,0,17.372,21.7c1.018-.483,1.975-1.092,2.96-1.644l-.025-.21c-.6-.378-1.178-.792-1.8-1.131a29.91,29.91,0,0,0-9.744-3,10.176,10.176,0,0,1-7.744-5.244A18.582,18.582,0,0,1,0,7.651V5.77m7.134-1.7c-.08.006-.32.014-.557.044a2.676,2.676,0,0,0-2.32,3.733,6.139,6.139,0,0,0,6.718,3.741A2.615,2.615,0,0,0,13,8.018,6.2,6.2,0,0,0,7.134,4.065m.113,31.723a6.3,6.3,0,0,0,5.479-3.277c1.084-2.144.141-3.973-2.229-4.32a6.181,6.181,0,0,0-6.2,3.7,2.681,2.681,0,0,0,.488,3.026,3.26,3.26,0,0,0,2.458.872",
    transform: "translate(0 0.002)",
    fill: "#161615"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgScissors);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Scissors.e82bc815ce8f4f13ba65b88bf8d98dbf.svg";